import { GuestServiceStatusOptions } from '@hkm/components/Attendant/shared/models/GuestServiceStatusOptions';
import { GuestServiceStatusType } from '@hkm/shared/enum/guestServiceStatusType';

export function getGuestServiceStatus(props: GuestServiceStatusOptions): GuestServiceStatusType | undefined {
  return Object.values(GuestServiceStatusType).find(key => props[key]) as GuestServiceStatusType;
}



// WEBPACK FOOTER //
// ./src/components/Attendant/shared/utils/getGuestServiceStatus.ts